import { styled } from '@mui/material/styles';

export const TitleCompWrapper = styled('div')(() => ({
	'&:not(:empty)': {
		marginBottom: 16,
	},
}));
